<template>
    <div class="my-root">
        <Top></Top>
        <div class="my-header">
            <div class="my-content">
                <span class="head-icon"></span>
                <div>
                    <p>
                        <span class="name">HI,{{ userInfo.name ? userInfo.name : userInfo.uid }}</span>
                        <span v-show="!userInfo.name" @click="setName()" style="color: #eaeeff;margin-left: 10px;cursor: pointer">{{ $t('m.my.index.text[2]') }}</span>
                        <span class="uid">UID:{{userInfo.uid}}</span>
                    </p>
                    <p>
                        <span class="text">IP:{{lineIP}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="my-body___1UbSf ">
            <div class="side-menu-layout">
                <div class="content_main">
                    <div class="card-box">
                        <h2>{{$t('m.my.text.title')[0]}}</h2>
                        <div class="content">
                            <!--安全等级-->
                            <ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">{{ $t('m.my.index.safe[1]') }}：
                                        <template v-if="userInfo.is_google && userInfo.email && userInfo.mobile">{{ $t('m.my.index.safe[4]') }}</template>
                                        <template v-else-if="(userInfo.is_google && userInfo.email) || (userInfo.is_google && userInfo.mobile) || (userInfo.email && userInfo.mobile)">{{ $t('m.my.index.safe[3]') }}</template>
                                        <template v-else>{{ $t('m.my.index.safe[2]') }}</template>
                                    </p>
                                    <p>{{$t('m.my.text')[2]}}</p>
                                </li>
                                <li class="operation">
                                    <div class="strength-bar" v-if="userInfo.is_google && userInfo.email && userInfo.mobile">
                                        <span class="low"></span>
                                        <span class="low"></span>
                                        <span class="low"></span>
                                    </div>
                                    <div class="strength-bar" v-else-if="(userInfo.is_google && userInfo.email) || (userInfo.is_google && userInfo.mobile) || (userInfo.email && userInfo.mobile)">
                                        <span class="low"></span>
                                        <span class="low"></span>
                                        <span></span>
                                    </div>
                                    <div class="strength-bar" v-else>
                                        <span class="low"></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </li>
                            </ul>
                            <!--实名认证-->
                            <ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">{{ $t('m.my.nav[2]') }}</p>
                                    <p>{{$t('m.my.text')[0]}}</p>
                                </li>
                                <li class="operation">
                                    <div>
                                        <el-button type="text" v-if="userInfo.is_auth == 1"
                                                   :disabled="isDisabled">{{$t('m.my.index.success') }}
                                        </el-button>
                                        <el-button type="text" v-else @click="changeRoute('/realname')">
                                            {{$t('m.my.index.approve') }}
                                        </el-button>
                                    </div>
                                </li>
                            </ul>
                            <!--邮箱-->
                            <ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">{{ $t('m.my.index.bind[2]') }}</p>
                                    <p>{{$t('m.my.text')[1]}}</p>
                                </li>
                                <li class="operation">
                                    <div v-if="userInfo.email">
                                        <em>{{ userInfo.email | emailChange }}</em>
<!--                                        <span class="vertical-line" @click="changeRoute('/new_email')">-->
<!--                                             <el-button type="text">{{$t('m.my.text.title')[1]}}</el-button>-->
<!--                                        </span>-->
                                        <!--<el-button type="text" :disabled="isDisabled">{{$t('m.my.text.title')[2]}}
                                        </el-button>-->
                                    </div>
                                    <div v-else>
                                        <el-button type="text" @click="changeRoute('/new_email')">{{$t('m.my.text.title')[3]}}</el-button>
                                    </div>
                                </li>
                            </ul>
                            <!--手机-->
                            <ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">{{ $t('m.my.index.bind[3]') }}</p>
                                    <p>{{$t('m.my.text')[1]}}</p>
                                </li>
                                <li class="operation">
                                    <div v-if="userInfo.mobile">
                                        <em>{{ userInfo.mobile | phoneChange }}</em>
<!--                                        <span class="vertical-line" @click="changeRoute('/new_phone')">-->
<!--                                             <el-button type="text">{{$t('m.my.text.title')[4]}}</el-button>-->
<!--                                        </span>-->
                                        <!--<el-button type="text" :disabled="isDisabled">{{$t('m.my.text.title')[2]}}
                                        </el-button>-->
                                    </div>
                                    <div v-else>
                                        <el-button type="text" @click="changeRoute('/new_phone')">{{$t('m.my.text.title')[3]}}</el-button>
                                    </div>
                                </li>
                            </ul>
                            <!--谷歌验证器-->
                            <ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">{{ $t('m.my.index.bind[4]') }}</p>
                                    <p>{{$t('m.my.text')[4]}}</p>
                                </li>
                                <li class="operation">
                                    <div>
                                        <el-button type="text" @click="modal = true" style="margin-right: 20px">{{ $t('m.my.index.text[6]') }}</el-button>
                                        <el-button type="text" v-if="userInfo.is_google == 0" @click="changeRoute('/my/google')">{{
                                            $t('m.my.index.bind[0]') }}
                                        </el-button>
                                        <!--<div v-else-if="userInfo.is_google == 1">
                                            <span class="vertical-line" @click="changeStatus('2')">
                                                <el-button type="text">{{ $t('m.my.index.bind[11]') }}</el-button>
                                            </span>
                                            <el-button type="text" :disabled="isDisabled">{{ $t('m.my.index.bind[12]') }}</el-button>
                                        </div>
                                        <div v-else>
                                            <span class="vertical-line" @click="changeStatus('1')">
                                                <el-button type="text">{{ $t('m.my.index.bind[10]') }}</el-button>
                                            </span>
                                            <el-button type="text" :disabled="isDisabled">{{ $t('m.my.index.bind[13]') }}</el-button>
                                        </div>-->
                                        <el-button type="text" :disabled="isDisabled" v-else-if="userInfo.is_google == 1">{{ $t('m.my.index.bind[12]') }}</el-button>
                                    </div>
                                </li>
                                <Modal v-model="modal"
                                       :title="$t('m.my.index.text[3]')">
                                    <div style="font-size: 16px;display: flex;justify-content: space-around">
                                        <div style="width: 45%;text-align: center">
                                            <div>{{ $t('m.my.index.text[4]') }}</div>
                                            <img src="@/assets/img/winerbit/android.png" style="width: 200px;height: 200px">
                                        </div>
                                        <div style="width: 45%;text-align: center">
                                            <div>{{ $t('m.my.index.text[5]') }}</div>
                                            <img src="@/assets/img/winerbit/ios.png"  style="width: 200px;height: 200px">
                                        </div>
                                    </div>
                                </Modal>
                            </ul>
                        </div>
                    </div>
                    <div class="card-box">
                        <h2>{{$t('m.my.text.title')[5]}}</h2>
                        <div class="content">
                            <!--登录密码-->
                            <ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">{{$t('m.my.text.title')[6]}}</p>
                                    <p>{{$t('m.my.text')[3]}}</p>
                                </li>
                                <li class="operation">
                                    <div>
                                        <el-button type="text" @click="changeRoute('/login_pwd')">
                                            {{$t('m.my.safe.bind.handle')[1]}}
                                            <!--<template v-else>{{$t('m.my.safe.bind.handle')[0]}}</template>-->
                                        </el-button>
                                    </div>
                                </li>
                            </ul>
                            <!--API-->
                            <!--<ul>
                                <li class="icon"></li>
                                <li class="info">
                                    <p class="subtitle">API</p>
                                    <p></p>
                                </li>
                                <li class="operation">
                                    <div>
                                        <span class="text">{{ $t('m.my.index.bind[5]') }} {{
                                        apiList.length }} API {{ $t('m.my.index.bind[6]') }}</span>
                                        <el-button type="text" @click="changeRoute('/api')">{{$t('m.my.safe.bind.handle')[0]}}</el-button>
                                    </div>
                                </li>
                            </ul>-->
                        </div>
                    </div>
                    <!--<div class="overview___2frwT">-->
                    <!--<div class="profile___3Fhok">-->
                    <!--<div class="avatarWrapper___204Kt">-->
                    <!--<span class="ant-avatar avatar___3kK31 kc-avatar ant-avatar-circle ant-avatar-image">-->
                    <!--<img src="@/assets/img/touxiang.svg" alt="">-->
                    <!--</span>-->
                    <!--<div class="simpleInfo___n6ZXo">-->
                    <!--<div class="simple_email___316YM" v-if="!userInfo.email">{{ userInfo.mobile |-->
                    <!--phoneChange }}-->
                    <!--</div>-->
                    <!--<div class="simple_email___316YM" v-else>{{ userInfo.email | emailChange }}</div>-->
                    <!--<span class="simple_verified___K9E-m">{{ $t('m.my.index.approve') }}</span>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="infoCards___2FzTA">-->
                    <!--<div class="infoCardWrapper___3ERvm infoCardVerified___32j8m"-->
                    <!--@click="changeRoute('/realname')">-->
                    <!--<div class="c_name___1qxYe">-->
                    <!--<span>{{ $t('m.my.nav[2]') }}</span>-->
                    <!--<img src="@/assets/img/right_white.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="c_info___k8t1J">{{ $t('m.my.index.login.title[3]') }}: {{-->
                    <!--$t('m.my.index.approve') }}-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="infoCardWrapper___3ERvm infoCardSecurity___2YZX6"-->
                    <!--@click="changeRoute('/safe')">-->
                    <!--<div class="c_name___1qxYe">-->
                    <!--<span>{{ $t('m.my.index.safe[0]') }}</span>-->
                    <!--<img src="@/assets/img/right_white.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="c_info___k8t1J">{{ $t('m.my.index.safe[1]') }}: {{-->
                    <!--$t('m.my.index.safe[2]') }}-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="fields___15F02">-->
                    <!--<div class="fieldsRow___14hax">-->
                    <!--<div class="fieldsCard___2B6iF" @click="changeRoute('/new_email')">-->
                    <!--<div class="fieldsCard___2B6iF-img">-->
                    <!--<img src="@/assets/img/youjian.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="rightPart___33mUX">-->
                    <!--<div class="fieldsContentWrap___1cfd0">-->
                    <!--<h3 class="fieldsTitle___kWrS5">-->
                    <!--{{ $t('m.my.index.bind[2]') }}-->
                    <!--<img src="@/assets/img/gou.svg" alt="" v-show="userInfo.email">-->
                    <!--</h3>-->
                    <!--<div class="fieldsContent___3jr15" v-if="userInfo.email">{{ userInfo.email |-->
                    <!--emailChange }}-->
                    <!--</div>-->
                    <!--<div class="fieldsContent___3jr15 fieldsContent_red___1Z0XO" v-else>-->
                    <!--<span>{{ $t('m.my.index.bind[0]') }}</span>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="hoverArrow___2Vy9S">-->
                    <!--<div class="icon">-->
                    <!--<img src="@/assets/img/right_blue_other.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="fieldsCard___2B6iF" @click="changeRoute('/new_phone')">-->
                    <!--<div class="fieldsCard___2B6iF-img">-->
                    <!--<img src="@/assets/img/shouji.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="rightPart___33mUX">-->
                    <!--<div class="fieldsContentWrap___1cfd0">-->
                    <!--<h3 class="fieldsTitle___kWrS5">-->
                    <!--{{ $t('m.my.index.bind[3]') }}-->
                    <!--<img src="@/assets/img/gou.svg" alt="" v-show="userInfo.mobile">-->
                    <!--</h3>-->
                    <!--<div class="fieldsContent___3jr15" v-if="userInfo.mobile">{{ userInfo.mobile-->
                    <!--| phoneChange }}-->
                    <!--</div>-->
                    <!--<div class="fieldsContent___3jr15 fieldsContent_red___1Z0XO" v-else>-->
                    <!--<span>{{ $t('m.my.index.bind[0]') }}</span>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="hoverArrow___2Vy9S">-->
                    <!--<div class="icon">-->
                    <!--<img src="@/assets/img/right_blue_other.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="fieldsCard___2B6iF" @click="changeRoute('/my/google')">-->
                    <!--<div class="fieldsCard___2B6iF-img">-->
                    <!--<img src="@/assets/img/google.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="rightPart___33mUX">-->
                    <!--<div class="fieldsContentWrap___1cfd0">-->
                    <!--<h3 class="fieldsTitle___kWrS5">-->
                    <!--{{ $t('m.my.index.bind[4]') }}-->
                    <!--<img src="@/assets/img/gou.svg" alt="" v-show="userInfo.isGoogle != 0">-->
                    <!--</h3>-->
                    <!--<div class="fieldsContent___3jr15" v-if="userInfo.isGoogle != 0">-->
                    <!--<span>{{ $t('m.my.index.bind[1]') }}</span>-->
                    <!--</div>-->
                    <!--<div class="fieldsContent___3jr15 fieldsContent_red___1Z0XO" v-else>-->
                    <!--<span>{{ $t('m.my.index.bind[0]') }}</span>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="hoverArrow___2Vy9S">-->
                    <!--<div class="icon">-->
                    <!--<img src="@/assets/img/right_blue_other.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="fieldsRow___14hax">-->
                    <!--<div class="fieldsCard___2B6iF" @click="changeTab('/api')">-->
                    <!--<div class="fieldsCard___2B6iF-img">-->
                    <!--<img src="@/assets/img/api.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="rightPart___33mUX">-->
                    <!--<div class="fieldsContentWrap___1cfd0">-->
                    <!--<h3 class="fieldsTitle___kWrS5">-->
                    <!--API-->
                    <!--</h3>-->
                    <!--<div class="fieldsContent___3jr15">{{ $t('m.my.index.bind[5]') }} {{-->
                    <!--apiList.length }} API {{ $t('m.my.index.bind[6]') }}-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="hoverArrow___2Vy9S">-->
                    <!--<div class="icon">-->
                    <!--<img src="@/assets/img/right_blue_other.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="fieldsCard___2B6iF" @click="changeRoute('/deal_pwd')">-->
                    <!--<div class="fieldsCard___2B6iF-img">-->
                    <!--<img src="@/assets/img/yaoshi.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="rightPart___33mUX" v-if="userInfo.dealpwd">-->
                    <!--<div class="fieldsContentWrap___1cfd0">-->
                    <!--<h3 class="fieldsTitle___kWrS5">-->
                    <!--{{ $t('m.my.index.bind[9]') }}-->
                    <!--<img src="@/assets/img/gou.svg" alt="">-->
                    <!--</h3>-->
                    <!--<div class="fieldsContent___3jr15">{{ $t('m.my.index.bind[1]') }}</div>-->

                    <!--</div>-->
                    <!--<div class="hoverArrow___2Vy9S">-->
                    <!--<div class="icon">-->
                    <!--<img src="@/assets/img/right_blue_other.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="rightPart___33mUX" v-else>-->
                    <!--<div class="fieldsContentWrap___1cfd0">-->
                    <!--<h3 class="fieldsTitle___kWrS5">-->
                    <!--{{ $t('m.my.index.bind[9]') }}-->
                    <!--</h3>-->
                    <!--<div class="fieldsContent___3jr15 fieldsContent_red___1Z0XO">{{-->
                    <!--$t('m.my.index.bind[0]') }}-->
                    <!--</div>-->

                    <!--</div>-->
                    <!--<div class="hoverArrow___2Vy9S">-->
                    <!--<div class="icon">-->
                    <!--<img src="@/assets/img/right_blue_other.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div style="width: 320px;"></div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
<!--                    <div class="overview___2frwT tablePart___1u4YA">
                        <div class="part_header___2u9LR">{{ $t('m.my.index.login.text[0]') }}</div>
                        <div class="ant-table-wrapper overview_table___7WlHZ">
                            <div class="ant-spin-nested-loading">
                                <div class="ant-spin-container">
                                    <div class="ant-table ant-table-default ant-table-scroll-position-left">
                                        <div class="ant-table-body">
                                            <table>
                                                <thead class="ant-table-thead">
                                                <tr>
                                                    <th>
                                                        <span>{{ $t('m.my.index.login.title[0]') }}</span>
                                                    </th>
                                                    <th>
                                                        <span>{{ $t('m.my.index.login.title[1]') }}</span>
                                                    </th>
                                                    <th>
                                                        <span>{{ $t('m.my.index.login.title[2]') }}</span>
                                                    </th>
                                                    <th>
                                                        <span>{{ $t('m.my.index.login.title[3]') }}</span>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody class="ant-table-tbody">
                                                <tr v-for="(v,k) in logLogin" v-bind:key="k"
                                                    class="ant-table-row  ant-table-row-level-0">
                                                    <td>
                                                        <div class="ipCol___3za3z">
                                                            <span>{{ v.ip }}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="cell_icon___3gWZm">
                                                            <img src="@/assets/img/diannao.png" alt="">
                                                            <span style="margin-left: 9px;" :title="v.method">{{ v.method }}</span>
                                                        </div>
                                                    </td>
                                                    <td>{{ GMTToStr(v.create_time) }}</td>
                                                    <td>
                                                        <span v-if="k == 0"
                                                              class="dot_span___1Pgj6 online___gsXQY">{{ $t('m.my.index.login.text[1]') }}</span>
                                                        <span v-else
                                                              class="dot_span___1Pgj6 ">{{ $t('m.my.index.login.text[2]') }}</span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="padding: 0 24px 24px 0;"></div>
                    </div>-->
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "my",
        components: {
            Top, Bottom
        },
        data() {
            return {
                active: 'my',
                logLogin: [],
                apiList: [],
                lineIP: '',
                isDisabled: true,
                nickname: '',
                modal: false
            }
        },
        created() {
            let invitecode = this.$route.query.invitecode;
            let name = this.$route.query.name;
            let account;
            let type;
            let uid = Number(this.$route.query.uid);
            let pwd = this.$route.query.pwd ? this.$route.query.pwd : '';
            let login = this.$route.query.login;
            if (invitecode || !name) {
                account = this.$route.query.mobile ? this.$route.query.mobile : this.$route.query.email;
                type = this.$route.query.mobile ? 2 : 1;
            } else {
                account = name;
                type = 3;
            }
            if (login) {
                this.doLogin(account,type,uid,pwd);
            }
            setTimeout(() => {
                if(this.userInfo.is_auth != 0) this.getAuthInfo();
                this.getUserInfo();
                // this.getApi();
            }, 2000);
        },
        methods: {
            doLogin(account,type,uid,pwd) {
                let paramData = this.signRequestLogin({
                  account: account,
                  enum: type,
                  pwd: pwd,
                  uid: uid,
                  deviceCode: this.deviceCode.code,
                  userAgent: this.deviceCode.userAgent
                });
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Login/login", paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aUserInfo({
                        key: null,
                        uid: null,
                        count: 0,
                        nationality: null,
                        mobile: null,
                        email: null,
                        assets: 0,
                        dealpwd: null,
                        invitecode: null,
                        is_api: 0,
                        is_auth: 0,
                        is_google: 0,
                        ad_auth: 0,
                        name: null,
                        sync: 1
                    });
                    localStorage.setItem("user", "");
                    localStorage.setItem("user", res);
                    this.aUserInfo(res);
                })
            },
            getAuthInfo() {
                let paramData =  this.signRequest({});
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/User/authDetail", {
                    params: paramData
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aUserInfo({is_auth: res.info.auth_status});
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    this.$message.error(e);
                })
            },
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            },
            getUserInfo() {
                let paramData =  this.signRequest({});
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/User/logLogin", {
                    params: paramData
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.logLogin = res.logLogin;
                    this.lineIP = this.logLogin[0].ip;
                }).catch(() => {
                    if (e == 20001) return;
                })
            },
            getApi: function () {
                let paramData =  this.signRequest({});
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/Api/apiList", {
                    params: paramData
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.apiList = res.list;
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                })
            },
            // 改变谷歌验证状态
            changeStatus(status) {
                let paramData = {
                  status: Number(status)
                };
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Google/status?token=" + this.userInfo.key, paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    if (status == '1') {
                        console.log(status);
                        this.userInfo.is_google = '1';
                    } else {
                        console.log(status);
                        this.userInfo.is_google = '2';
                    }
                    this.$message.success('修改成功');
                })
            },
            // 设置昵称
            setName() {
                this.$Modal.confirm({
                    title: this.$t('m.my.index.text[0]'),
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.nickname,
                                autofocus: true
                            },
                            on: {
                                input: (val) => {
                                    this.nickname = val;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        let paramData = {
                          nickname: this.nickname
                        };
                        paramData.signature = this.signature(paramData);
                        this.$axios.post(this.requestConfig.host + "/index/user/nickname?token=" + this.userInfo.key, paramData).then((res) => {
                            return this.checkResponse(res);
                        }).then((res) => {
                            this.aUserInfo({name: this.nickname});
                            let user = localStorage.getItem("user");
                            user.name = this.nickname;
                            localStorage.setItem("user", "");
                            localStorage.setItem("user", user);
                            this.$message.success(this.$t('m.my.index.text[1]'));
                        })
                    },
                    onCancel: () => {

                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/my.scss";

    .cell_icon___3gWZm span {
        width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
